<div class="col-12">
  <div class="table table--documents u-mb20 u-bt">
    <div class="thead thead--border">
      <div class="tr" style="border-bottom: 1px solid #d1d0c7 !important;">
        <div class="th"><b>Requisitos mina</b></div>
        <div class="th"><b>Estado del requisito</b></div>
        <div class="th"><b>Fechas de vigencia</b></div>
        <div class="th">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>
    <div class="tbody" *ngIf="isFormReady">
      <ng-container *ngFor="let item of mineDocuments; index as i">
        <ng-container *ngFor="let formGroup of [getformGroupByRowIndex(i)]">
          <div class="tr tr--load" *ngIf="asFormControl(formGroup.controls.isEnabled).value">
            <div class="td td--name">
              <p>{{item.description}} <app-tooltip [text]="item?.tooltip || ''"></app-tooltip>
              </p>
              <h6 class="txt txt--paragraph"> {{item.hint}} </h6>
            </div>
            <div class="td td--load td--file pt-md-3">
              <h5>Estado del requisito</h5>
              <div class="form form--required">
                <label for="" class="label" style="height: 11px;">
                </label>
                <select class="js-disabled" name="" id=""
                  [formControl]="asFormControl(formGroup.controls.documentStatusId)">
                  <option value="">Selecciona</option>
                  <ng-container *ngFor="let option of mineDocumentsStatus">
                    <option [value]="option.id">{{option.name}}</option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="td td--load td--calendar">
              <h5>Fecha de vigencia</h5>
              <div class="form form--required">
                <label for="" class="label">
                  Desde
                </label>
                <app-calendar
                  *ngIf="!item.dateFrom"
                  [controlForm]="asFormControl(formGroup.controls.dateFrom)">
                </app-calendar>
                <app-calendar
                  *ngIf="item.dateFrom"
                  [defaultDate]="asFormControl(formGroup.controls.dateFrom).value"
                  [controlForm]="asFormControl(formGroup.controls.dateFrom)"></app-calendar>
                <app-error-message [text]="documentDateFromError(i)"></app-error-message>
              </div>
            </div>
            <div class="td td--load td--calendar">
              <div class="form form--required">
                <label for="" class="label">
                  Hasta
                </label>
                <app-calendar
                  *ngIf="!item.dateUntil"
                  [controlForm]="asFormControl(formGroup.controls.dateUntil)">
                </app-calendar>
                <app-calendar
                  *ngIf="item.dateUntil"
                  [defaultDate]="asFormControl(formGroup.controls.dateUntil).value"
                  [controlForm]="asFormControl(formGroup.controls.dateUntil)"></app-calendar>
                <app-error-message [text]="documentDateRangeError(i)"></app-error-message>
              </div>
            </div>
          </div>
          <div class="tr tr--border-t" *ngIf="!asFormControl(formGroup.controls.isEnabled).value">
            <div class="td td--name td--pt">
              <p>{{item.description}} <app-tooltip [text]="item?.tooltip || ''"></app-tooltip>
              </p>
              <h6 class="txt txt--paragraph"> {{item.hint}} </h6>
            </div>
            <div class="td td--colspan">
              <p>{{getDisabledMessage(i)}}</p>
            </div>
          </div>
        </ng-container>
      </ng-container>


      <!-- <ng-container *ngIf="!item.isEnabled && item.disabledMessage">
        <div class="td td--colspan">
          <p>{{item.disabledMessage}}</p>
        </div>
      </ng-container> -->
    </div>
  </div>
  <div
      *ngIf="!isFormReady"
      style="display: flex; width: 100%; justify-content: center; height: 70px;"
  >
      <app-loader style="width: 100%;"></app-loader>
    </div>
</div>
